import React from 'react'
import { connect } from 'react-redux'
import {  Row, Table, FormControl, InputGroup } from 'react-bootstrap'

import SearchBarDashboard from '../../../components/SearchBarDashboard'
import PropertyTitle from '../../../components/PropertyTitle'
import FontAwesome from 'react-fontawesome'
import 'react-toggle/style.css'

import { SEARCH_INSTRUCTIONS, NO_SEARCH_RESULTS } from '../../messages'

import { getUserLicensesDashboard, switchLicensesUserId } from '../../../actions/user-actions'

class ChangeUserId extends React.Component {

    constructor() {
        super()
        this.state = { query: undefined, newUserId:undefined, isSearching: false }
      }
    
      componentDidMount() {
        if(this.props.query) {
          this.setState({ query: this.props.query })
        }

      }

      componentWillUnmount() {
        this.setState({ query: undefined, newUserId:undefined })
      }
    
      search(query) {
        this.setState({ query, isSearching: true })
        this.props.getUserLicensesDashboard(query).then(() => {
          this.setState({ isSearching: false })
        })
      }

      switch() {
        let oldUserId = Number(this.state.query)
        let newUserId2 = Number(this.state.newUserId)
        this.props.switchLicensesUserId(oldUserId,newUserId2 )
      }

      onChange(e) {
        this.setState({newUserId: e.target.value})
      }
    
      render() {
        const { results } = this.props
    
        return <div className='content-changeUserId' >
          <Row className='dashboardRowContainer'>
            <PropertyTitle 
              icon='user' 
              text=" Gebruikersaccount wijzigen" 
            />
          <Row >
            <div style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}}>
              <div style={{borderBottom:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"5px",  marginBottom:"10px"}}>
                Zoek licenties op basis van gebruikersaccount om deze te koppelen aan ander gebruikersaccount (user id)
                </div>
                <SearchBarDashboard style={{ backgroundColor:"white", padding:"5px",  marginTop:"5px"}}
                placeholder="Zoek gebruiker"
                value={this.state.query || this.props.query}
                callback={(query) => this.search(query)}
                isLoading={this.state.isSearching}
                />
              </div>
          </Row>
          </Row>
          <Row className='dashboardRowContainer'>
            {results.length? (
            <Row style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}}>
              <div>
                <FontAwesome name="user" className={'fa-solid fa-user'} size='2x'  />
                 Zoek licenties op basis van gebruikersaccount om deze te koppelen aan ander gebruikersaccount (user id)
               </div>
              <InputGroup style={{marginTop:"10px"}}>
                <FormControl 
                  type='number' 
                  autoFocus={true} 
                  defaultValue={this.props.value} 
                  placeholder={ this.props.placeholder } 
                  onChange={(e) => this.onChange(e)} 
                />
                <InputGroup.Button type='submit'>
                  <button className='button-dashboard' onClick={() => this.switch()}>
                    Toepassen
                  </button>
                </InputGroup.Button>
              </InputGroup>
            </Row>
            ) : (
              <div></div>
            ) }
          </Row>
        <Row >
          {
            results.length? (
            <PropertyTitle small text="Gevonden Licenties" style={{marginTop:"20px"}}  /> 
          ) : ( <div></div> )
          }
        
        </Row>
        <Row>
          <div className="tablescontainer" style={{marginTop:"5px"}}>
            {results.length? (
              <Table striped>
                <thead>
                  <tr>
                    <th>User Id</th>
                    <th>Activatiecode</th>
                    <th>Nav Id</th>
                    <th>Product Id</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((result, index) => (
                    <tr key={index} >
                      <td style={{overflowWrap: "anywhere"}}>{result.userId}</td>
                      <td style={{overflowWrap: "anywhere"}}>{result.activationCode}</td>
                      <td>{result.navId}</td>
                      <td>{result.productCode}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <SearchInfo />
            )}
          </div>
        </Row>
        </div>
      }

    
}

let SearchInfo = () => (
    <div>
      <p>{SEARCH_INSTRUCTIONS}</p>
      <p>Zoek op:</p>
      <ul>
        <li>User ID</li>
      </ul>
      <p>{NO_SEARCH_RESULTS}</p>
    </div>
  )

  export default connect((state) => {
    return { 
    results: state.dashboard.userLicenseSearchDashboard.results,
    query: state.dashboard.userLicenseSearchDashboard.query
  }}, {
    getUserLicensesDashboard,
    switchLicensesUserId
  })(ChangeUserId)